import React, { useContext, useState } from 'react'
import ReactQuill from 'react-quill';
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';
import AddChoice from './AddChoice';
import QuestionChoices from './QuestionChoices';

function SingleQuizQuestion({question, quizId, correctAmount, setCorrectAmount, index, isSubmitted, mode, answeredAmount, setAnsweredAmount}) {

    const appState = useContext(StateContext);

    const [show, setShow] = useState(false);

    // EDIT MODE
    const [showEditQuestion, setShowEditQuestion] = useState(false);

    const [questionText, setQuestionText] = useState(question.question)
    const [number, setNumber] = useState(question.number)
    const [content, setContent] = useState(question.content)

    const [error, setError] = useState("")
    const [message, setMessage] = useState("")

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true);
        }
    }

    async function editQuestionHandler(e) {
        e.preventDefault()
        try {
            const questionsRef = firestore.collection("quiz").doc(quizId).collection("questions").doc(question.id);
            const data = {
                question: questionText,
                number: number,
                content: content
            }
            questionsRef.update(data)
            setMessage("Oppdatert")
        } catch (error) {
            setError("Kunne ikke oppdatere")
        }
    }

    function toggleEdit() {
        if (showEditQuestion) {
            setShowEditQuestion(false)
        } else {
            setShowEditQuestion(true)
        }
    }

    return (
        <div>

            <p className="font-weight-bold my-2">{index+1}. {question.question}</p>

            {mode === "edit" && (
                <div>

                    <div>
                        <i onClick={toggleEdit} className={`fas fa-${showEditQuestion ? "times" : "edit"}`}></i>
                    </div>

                    {showEditQuestion && (
                        <form onSubmit={editQuestionHandler}>
                            <label>Spørsmål</label>
                            <input className="form-control mb-2" value={questionText} onChange={e => setQuestionText(e.target.value)} />

                            <label>Spml nr</label>
                            <input type="number" value={number} className="form-control mb-2" onChange={e => setNumber(e.target.value)} />
                            
                            <label>Innhold</label>
                            <ReactQuill theme="snow" value={content} onChange={setContent} />
                            <div className="my-3">
                                {error && <div className="alert alert-danger">{error}</div>}
                                {message && <div className="alert alert-success">{message}</div>}
                                <button className="btn btn-block btn-primary">Lagre</button>
                            </div>
                        </form>
                    )}

                </div>
            )}



            <QuestionChoices 
                questionId={question.id} 
                quizId={quizId} 
                correctAmount={correctAmount} 
                setCorrectAmount={setCorrectAmount} 
                answeredAmount={answeredAmount}
                setAnsweredAmount={setAnsweredAmount}
                isSubmitted={isSubmitted}
                mode={mode}
            />

            {appState.loggedIn && mode === "edit" && (
                <React.Fragment>
                    <button onClick={toggle}>+</button>
                    {show && (
                        <React.Fragment>
                            <h4>Legg til valg</h4>
                            <AddChoice quizId={quizId} questionId={question.id} />
                        </React.Fragment>
                    )}

                </React.Fragment>
            )}

        </div>
    )

}
export default SingleQuizQuestion